import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './assets/sass/app.scss'
import 'materialize-css/sass/materialize.scss'

Vue.config.productionTip = false
window.baseURL = '/api/'
window.axios = axios.create({
  baseURL: window.baseURL
})
Vue.prototype.$http = window.axios
Vue.prototype.$store = store

new Vue({
  router,
  render: h => h(App)
}).$mount('main')



// WEBPACK FOOTER //
// ./src/main.js